import React from 'react';
import { InstagramIcon, YoutubeIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const COLUMNS = [{
  title: 'Explore',
  links: [{
    label: 'Shop',
    href: '/#packages'
  }, {
    label: 'About Us',
    href: '/about'
  }, {
    label: 'Benefits',
    href: '/#why'
  }, {
    label: 'Ingredients',
    href: '/ingredients'
  }]
}, {
  title: 'Support',
  links: [{
    label: 'FAQs',
    href: '/#faq'
  }, {
    label: 'Contact',
    href: 'mailto:hello@medufit.com'
  }]
}, {
  title: 'Legal',
  links: [{
    label: 'Privacy',
    href: '#'
  }, {
    label: 'Terms',
    href: '#'
  }]
}];
const SOCIALS = [{
  label: 'Instagram',
  href: 'https://www.instagram.com/',
  Icon: InstagramIcon
}, {
  label: 'YouTube',
  href: 'https://www.youtube.com/',
  Icon: YoutubeIcon
}];
export function Footer() {
  return <footer className="w-full bg-ivory px-6 pb-10 pt-16 md:px-10 lg:px-16" data-id="element-111" data-mp="2a19uhoqc1syc">
      <div className="mx-auto max-w-7xl" data-id="element-112" data-mp="2ezutjktum6l7">
        <div className="grid gap-10 border-b border-forest/12 pb-12 md:grid-cols-[1.5fr_1fr_1fr_1fr]" data-id="element-113" data-mp="3l9k292unj58j">
          <div data-id="element-114" data-mp="3gapb9dmj6adc">
            <Link to="/#top" className="block h-9 w-40 overflow-hidden" data-id="element-115" data-mp="3gb8v4zvqr8u0">
              <img src="https://cdn.magicpatterns.com/uploads/5PdRrCyrBFpFZN2QamF6sU/medufit_logo_new.png" alt="Medufit" className="h-full w-full object-contain object-left mix-blend-multiply" data-id="element-116" data-mp="3v7q6vs7ueph3" />
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-forest/60" data-id="element-117" data-mp="80xkia4293k5">
              Daily complete nutrition, made simple with plant botanicals and modern nutritional care.
            </p>
            <div className="mt-5 flex items-center gap-4" data-id="element-118" data-mp="huwhkupa1x58">
              {SOCIALS.map(({
              label,
              href,
              Icon
            }) => <a key={label} href={href} target="_blank" rel="noreferrer" className="text-forest/70 transition-colors hover:text-forest" aria-label={label} data-id="element-119" data-mp="qthy6kb6v23d">
                  <Icon className="h-5 w-5" data-id="element-120" data-mp="tt0ayvxa0wt4" />
                </a>)}
            </div>
          </div>

          {COLUMNS.map(col => <div key={col.title} data-id="element-121" data-mp="13t0xsructv22">
              <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-sage" data-id="element-122" data-mp="13rzkegpv8wh6">{col.title}</h3>
              <ul className="mt-4 space-y-3" data-id="element-123" data-mp="18m3qyyv7z2hq">
                {col.links.map(link => <li key={link.label} data-id="element-124" data-mp="1clclw71zx6ev">
                    {link.href.startsWith('mailto:') ? <a href={link.href} className="text-sm text-forest/70 transition-colors hover:text-forest" data-id="element-125" data-mp="1hiulh6u4i9a7">
                        {link.label}
                      </a> : link.href === '#' ? <a href={link.href} onClick={event => event.preventDefault()} className="text-sm text-forest/70 transition-colors hover:text-forest" data-id="element-126" data-mp="1rgiosl5sop3z">
                        {link.label}
                      </a> : <Link to={link.href} className="text-sm text-forest/70 transition-colors hover:text-forest" data-id="element-127" data-mp="25ncae2y0u44k">
                        {link.label}
                      </Link>}
                  </li>)}
              </ul>
            </div>)}
        </div>

        <div className="flex flex-col items-center justify-between gap-3 pt-6 text-xs text-forest/50 sm:flex-row" data-id="element-128" data-mp="2tcy9yrib2ld3">
          <p data-id="element-129" data-mp="2pcw6qdwx9jvp">© {new Date().getFullYear()} Medufit. All rights reserved.</p>
          <p data-id="element-130" data-mp="2kci5beptt86n">FDA Registered Facility</p>
        </div>
      </div>
    </footer>;
}